import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Tooltip } from "@mui/material";
import { ThunkDispatch } from "@reduxjs/toolkit";
import FilterListIcon from "@mui/icons-material/FilterList";
import { setSideBarFiltersVisible } from "../../../../../../../redux/slices/dataTable/data";
import { State } from "../../../../../../../redux/slices";
import { useTranslation } from "react-i18next";
import { DataTableFiltersStyles } from "../FiltersSideBarStyles";
import { ButtonMenuDataTableProps } from "../../export/ExportButton";
import DataTableColumns from "../../../../columnsAndActions/ColumnsAndActions";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    setSideBarFiltersVisible: (visible: boolean) => {
      dispatch(setSideBarFiltersVisible(visible));
    },
  };
};

const SideBarFiltersButton: FC<ButtonMenuDataTableProps> = ({
  loading,
  disabled = false,
}) => {
  const [t] = useTranslation("global");
  const { setSideBarFiltersVisible } = SetActions();
  const { actionsDataTable } = DataTableColumns();
  const { filtersSelected } = useSelector(
    (state: State) => state.DataFiltersReducer
  );

  const hasNoData = actionsDataTable.length === 0;

  return (
    <div>
      <Tooltip
        title={
          hasNoData && filtersSelected > 0 ? t("Data.no_results_filters") : ""
        }
        arrow
      >
        <Button
          variant="outlined"
          onClick={() => setSideBarFiltersVisible(true)}
          sx={{
            ...DataTableFiltersStyles.DataFiltersSideBarButton,
            ...(hasNoData && filtersSelected > 0 && { background: "#ff9800" }),
          }}
          disabled={loading || disabled}
        >
          <FilterListIcon sx={DataTableFiltersStyles.FiltersIcon} />
          <div className="mr-1" style={DataTableFiltersStyles.FiltersIconDiv}>
            {t("Data.Filter")}
          </div>
          {filtersSelected >= 1 ? `(${filtersSelected})` : ""}
        </Button>
      </Tooltip>
    </div>
  );
};

export default SideBarFiltersButton;
